module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  switch (type) {
case "command":
    ; __append("\r\n<li style=\"padding-left: 1.3em;display: block;\" class=\"table-ellipsis command-tree\" title=\"")
    ; __append(escapeFn(tooltip))
    ; __append("\">\r\n    <a data-target=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-select field-list-toggle command-result\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"label\"\r\n       instance-id=\"")
    ; __append(escapeFn(instanceId))
    ; __append("\" data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(controls[0].name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n        ")
    ; __append(escapeFn(controls[0].name ))
    ; __append("\r\n    </a>\r\n    <ul class=\"control-list ")
    ; __append(escapeFn(id))
    ; __append("\" id=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" style=\"display: none; padding-left: 0\"></ul>\r\n</li>\r\n")
    ;  break;
case "behavior": 
    ; __append("\r\n<li style=\"padding-left: 1.3em;display: block;\" class=\"table-ellipsis behavior-tree\">\r\n    <a data-target=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-select field-list-toggle behavior-result\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"toggle\"\r\n       data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n        <i class=\"fa pf-carot-left pf-rotate-icon\" aria-expanded=\"true\"></i>\r\n    </a>\r\n    <a data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-select field-list-toggle behavior-result\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"label\"\r\n       data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n        ")
    ; __append(escapeFn(text ))
    ; __append("\r\n    </a>\r\n    <ul class=\"control-list ")
    ; __append(escapeFn(id))
    ; __append("\"  id=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" data-selected-control=\"")
    ; __append(escapeFn(controlId))
    ; __append("\"  style=\"display: none;\" title=\"")
    ; __append(escapeFn(tooltip))
    ; __append("\">\r\n        <li style=\"padding-left: 1.3em;display: block;\" class=\"table-ellipsis command-tree\">\r\n            <a data-target=\"")
    ; __append(escapeFn( ownerId + "-" + behaviorKey + "-" + controls[0].id))
    ; __append("\" class=\"field-select field-list-toggle command-result\" id=\"field-select-")
    ; __append(escapeFn( ownerId + "-" + behaviorKey + "-" + controls[0].id))
    ; __append("\" data-kind=\"label\"\r\n               instance-id=\"")
    ; __append(escapeFn( instanceId ))
    ; __append("\"\r\n               data-selected-item=\"")
    ; __append(escapeFn( ownerId + "-" + behaviorKey + "-" + controls[0].id))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(controls[0].name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n                ")
    ; __append(escapeFn(controls[0].name ))
    ; __append("\r\n            </a>\r\n            <ul id=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" class=\"control-list ")
    ; __append(escapeFn( ownerId + "-" + behaviorKey + "-" + controls[0].id))
    ; __append("\" style=\"display: none;\"></ul>\r\n        </li>\r\n    </ul>\r\n</li>\r\n")
    ;  break;
case "app-behavior": 
    ; __append("\r\n<li style=\"padding-left: 1.3em;display: block;\" class=\"table-ellipsis behavior-tree\">\r\n    <a data-target=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-select field-list-toggle behavior-result\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"toggle\"\r\n       data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n        <i class=\"fa pf-carot-left pf-rotate-icon\" aria-expanded=\"true\"></i>\r\n    </a>\r\n    <a data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-select field-list-toggle behavior-result\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"label\"\r\n       data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n        ")
    ; __append(escapeFn(text ))
    ; __append("\r\n    </a>\r\n    <ul class=\"control-list control-list ")
    ; __append(escapeFn( ownerId + "-" + behaviorKey ))
    ; __append("\"  id=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" data-selected-control=\"")
    ; __append(escapeFn(controlId))
    ; __append("\"  style=\"display: none;\" title=\"")
    ; __append(escapeFn(tooltip))
    ; __append("\">\r\n        <li style=\"padding-left: 1.3em;display: block;\" class=\"table-ellipsis command-tree\">\r\n            <a data-target=\"")
    ; __append(escapeFn( ownerId + "-" + behaviorKey + "-" + controls[0].id))
    ; __append("\" class=\"field-select field-list-toggle command-result\" id=\"field-select-")
    ; __append(escapeFn( ownerId + "-" + behaviorKey + "-" + controls[0].id))
    ; __append("\" data-kind=\"label\"\r\n               instance-id=\"")
    ; __append(escapeFn( instanceId ))
    ; __append("\"\r\n               data-selected-item=\"")
    ; __append(escapeFn( ownerId + "-" + behaviorKey + "-" + controls[0].id))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(controls[0].name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n                ")
    ; __append(escapeFn(controls[0].name ))
    ; __append("\r\n            </a>\r\n           \r\n        </li>\r\n    </ul>\r\n</li>\r\n")
    ;  break;
case "control": 
    ; __append("\r\n<li style=\"padding-left: 1.3em;display: block;\" class=\"table-ellipsis control-tree\" title=\"")
    ; __append(escapeFn(rootControlTooltip))
    ; __append("\" >\r\n    <a data-target=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\"  class=\"field-select field-list-toggle control-result\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"toggle\"\r\n       data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n        <i class=\"fa pf-carot-left pf-rotate-icon\" aria-expanded=\"true\"></i>\r\n    </a>\r\n    <a data-target=\"")
    ; __append(escapeFn(controlId))
    ; __append("\" class=\"field-select field-list-toggle control-result\" id=\"field-select-")
    ; __append(escapeFn( id ))
    ; __append("\" data-kind=\"label\"\r\n       data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n        ")
    ; __append(escapeFn(name))
    ; __append("\r\n    </a>\r\n    <ul class=\"control-list ")
    ; __append(escapeFn(controlId))
    ; __append("\"  id=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" style=\"display: none;\"  data-selected-control=\"")
    ; __append(escapeFn(controlId))
    ; __append("\">\r\n        <li style=\"padding-left: 1.3em;display: block;\" class=\"table-ellipsis behavior-tree\">\r\n            <a data-target=\"control-list-")
    ; __append(escapeFn(ownerId + "-" + behaviorKey))
    ; __append("\"  class=\"field-select field-list-toggle behavior-result\" id=\"field-select-")
    ; __append(escapeFn( ownerId))
    ; __append("\" data-kind=\"toggle\"\r\n               data-selected-item=\"")
    ; __append(escapeFn(ownerId + "-" + behaviorKey))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(behaviorKey))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n                <i class=\"fa pf-carot-left pf-rotate-icon\" aria-expanded=\"true\"></i>\r\n            </a>\r\n            <a data-target=\"")
    ; __append(escapeFn(ownerId + "-" + behaviorKey))
    ; __append("\" class=\"field-select field-list-toggle behavior-result\" id=\"field-select-")
    ; __append(escapeFn( ownerId))
    ; __append("\" data-kind=\"label\"\r\n               data-selected-item=\"")
    ; __append(escapeFn(ownerId + "-" + behaviorKey ))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(behaviorKey))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n                ")
    ; __append(escapeFn( text ))
    ; __append("\r\n            </a>\r\n            <ul id=\"control-list-")
    ; __append(escapeFn(ownerId + "-" + behaviorKey))
    ; __append("\" class=\"control-list ")
    ; __append(escapeFn( ownerId + "-" + behaviorKey ))
    ; __append("\" style=\"display: none;\" title=\"")
    ; __append(escapeFn(tooltip))
    ; __append("\">\r\n                <li style=\"padding-left: 1.3em;display: block;\" class=\"table-ellipsis command-tree\">\r\n                    <a data-target=\"")
    ; __append(escapeFn( ownerId + "-" + behaviorKey + "-" + controls[0].id))
    ; __append("\" class=\"field-select field-list-toggle command-result\" id=\"field-select-")
    ; __append(escapeFn( ownerId + "-" + behaviorKey ))
    ; __append("\" data-kind=\"label\"\r\n                       instance-id=\"")
    ; __append(escapeFn(id))
    ; __append("\"  data-selected-item=\"")
    ; __append(escapeFn( ownerId + "-" + behaviorKey + "-" + controls[0].id))
    ; __append("\" data-selected-name=\"")
    ; __append(escapeFn(controls[0].name))
    ; __append("\" data-selected-key=\"")
    ; __append(escapeFn(factoryKey))
    ; __append("\" style=\"font-weight:bolder;color: var(--main-primary)\">\r\n                        ")
    ; __append(escapeFn(controls[0].name ))
    ; __append("\r\n                    </a>\r\n                    <ul class=\"control-list ")
    ; __append(escapeFn(  ownerId + "-" + behaviorKey + "-" + controls[0].id))
    ; __append("\" style=\"display: none;\"></ul>\r\n                </li>\r\n            </ul>\r\n        </li>\r\n    </ul>\r\n</li>\r\n")
    ;  break;
}

  }
  return __output;

}